export default __webpack_public_path__ + "static/media/broker-template-1-fr.2b2710d1.svg";